import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@ublend-npm/react-tooltip';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import Loader from '@ublend-npm/aulaui-next-web/Loader';

import {
  ListItemSecondaryAction,
  CircularProgressContainer,
  IconButton,
} from './ParticipantSecondaryAction.styled';

const ParticipantSecondaryAction = ({
  isCurrentUser,
  isEducator,
  isCreatingConversation,
  onMessage,
  onRemove,
  currentUserIsEducator,
}) => {
  if (isCurrentUser) {
    return null;
  }

  const removeLabel = 'Remove from this space';
  const messageUserLabel = 'Message the user';

  return (
    <ListItemSecondaryAction>
      {isEducator && currentUserIsEducator && (
        <Tooltip title={removeLabel} position="top">
          <IconButton
            size="medium"
            color="primary"
            type="tertiary"
            label={removeLabel}
            onClick={onRemove}
            icon={RemoveCircleIcon}
          />
        </Tooltip>
      )}
      {isCreatingConversation ? (
        <CircularProgressContainer>
          <Loader size={15} />
        </CircularProgressContainer>
      ) : (
        <Tooltip title={messageUserLabel} position="top">
          <IconButton
            size="medium"
            color="primary"
            type="tertiary"
            label={messageUserLabel}
            onClick={onMessage}
            icon={ChatBubbleIcon}
          />
        </Tooltip>
      )}
    </ListItemSecondaryAction>
  );
};

ParticipantSecondaryAction.propTypes = {
  isCurrentUser: PropTypes.bool,
  currentUserIsEducator: PropTypes.bool.isRequired,
  isEducator: PropTypes.bool,
  isCreatingConversation: PropTypes.bool,
  onMessage: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

ParticipantSecondaryAction.defaultProps = {
  isCurrentUser: false,
  isEducator: false,
  isCreatingConversation: false,
};

export default ParticipantSecondaryAction;
